.navigation {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  > section,
  > section + section {
    margin-top: 0;
    flex-shrink: 0;
    display: grid;
    gap: 0.125rem;
  }

  > section > div {
    gap: 0.125rem;
  }

  a,
  button {
    min-height: 2.25rem;
    padding-block: 0.375rem;
  }

  > a {
    flex-shrink: 0;
  }
}
